// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import React from 'react';
import {Oauth_button} from '@pub/comp/oauth_button';
import {ENABLED_OAUTH_PROVIDERS, MAX_REF_LEN,
    MAX_PROMO_LEN} from '@pub/shared/constants.js';
import {Form_input, FIELD_KIND, PASSWORD_KIND} from '@pub/comp/form';
import {EMAIL_FIELD, MAX_PASS_LEN, MAX_EMAIL_LEN} from './constants.js';
import * as ccns from './common.module.less';

export function Email_input(){
    return <Form_input id="email" className={ccns.input} title="Work email"
      required field={EMAIL_FIELD} max_len={MAX_EMAIL_LEN} name="username"
      placeholder="name@company.com" kind={FIELD_KIND.EMAIL} is_mono_font
      ico="ico_user" auto_focus autocomplete="email"/>;
}

export function Password_input({password_kind}){
    const is_signin = password_kind==PASSWORD_KIND.SIGNIN;
    return <Form_input id="password" className={ccns.input} title="Password"
      required field="password" max_len={MAX_PASS_LEN} name="password"
      placeholder="password" kind={FIELD_KIND.PASSWORD} is_mono_font
      password_kind={password_kind}
      autocomplete={is_signin ? 'current-password' : 'new-password'}
      ico="ico_password"/>;
}

export function Oauth_list({action}){
    const items = [];
    for (const provider of ENABLED_OAUTH_PROVIDERS)
    {
        items.push(<li className={ccns.alt} key={provider}>
          <Oauth_button className={ccns.oauth_btn} action={action}
            provider={provider}/>
        </li>);
    }
    if (!items.length)
        return null;
    return <ul className={ccns.alts_list}>{items}</ul>;
}

export const shorten_promo = v=>v.slice(0, MAX_PROMO_LEN);

export const shorten_ref = v=>v.slice(0, MAX_REF_LEN);

export const get_error = code=>{
    const err = new Error();
    err.code = code;
    return err;
};

export const Auth_ctx = React.createContext();
